<template>
  <div class="home mb-16">
    <div class="title py-2 px-4 title-div mb-3">
      News & Information
    </div>
    <div>
      <v-tabs class="mb-3">
        <v-tab @click="newsType = 'Press Releases'">Press Releases</v-tab>
        <v-tab @click="newsType = 'Announcements'">Announcements</v-tab>
        <!-- <v-tab @click="newsType = 'Replies'">Replies</v-tab> -->
        <v-tab @click="newsType = 'Speeches'">Speeches</v-tab>
      </v-tabs>
    </div>
    <p class="warning--text" v-if="featuredNews.length <= 0">No {{newsType}} found</p>
    <v-row>
      <v-col cols="12" md="4" v-for="(news) in featuredNews" :key="news.Title">
        <v-img
          :src="getImage(news)"
          class="transparent"
          aspect-ratio="1.4"
          >
          <template v-slot:placeholder>
            <v-layout
              fill-height
              align-center
              justify-center
              ma-0
              >
              <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <p class="mt-3 mb-1"><a class="title news-title" :href="`#/Media/${newsType}/${news.ID}`">{{news.Title}}</a></p>
        <p class="grey--text">{{news.Date | moment('DD-MM-YYYY')}}</p>
      </v-col>
    </v-row>
    <a :href="`#/Media/${newsType}`">View More {{newsType}}</a>

    <!-- <div class="title py-2 px-4 title-div mt-5 mb-3">
      What we do
    </div> -->
    <!-- <div class="title py-2 px-4 title-div mt-5 mb-3">
      Latest from Attorney General's Office
    </div> -->
    <div class="title py-2 px-4 title-div mt-5 mb-3">
      Announcements
    </div>
    <div v-for="(n, index) in announcements" :key="n.Title">
      <p class="mb-0" ><a class="title" :href="'#/Media/Announcements/' + n.ID" v-html="n.Title"></a></p>
      <p class="grey--text">{{n.Date | moment("DD-MM-YYYY")}}</p>
      <v-divider class="my-2" v-if="index != announcements.length-1"></v-divider>
    </div>
    <!-- <div class="title py-2 px-4 title-div mt-5 mb-3">
      Legislative Agenda
    </div> -->
    <!-- <div class="title py-2 px-4 title-div mt-5 mb-3">
      Directives
    </div> -->
    <div class="title py-2 px-4 title-div mt-5 mb-3">
      <a href="https://www.gov.mv/en/publications/govmv-message-user-manual">GOV.MV Message is now live</a>
    </div>
    <div class="title py-2 px-4 title-div mt-5 mb-3">
      Forms
    </div>
    <v-row>
      <v-col cols="12" sm="6">
        <p class="mb-4 font-weight-bold">Information Request</p>
        <div v-for="(form, index) in getForms('Information Request')" :key="form.Title + form.ID">
          <p class="mb-0" ><a class="title" v-html="form.Title"></a></p>
          <span v-for="file in form.Files" :key="file.ID + file.FileName">
            <v-btn color="red" :href="`${$url}/downloadfile/${file.ID}`" v-if="file.UniqueFileName.includes('.pdf')" text icon><v-icon>mdi-file-pdf-outline</v-icon></v-btn>
            <v-btn color="info" :href="`${$url}/downloadfile/${file.ID}`" v-else-if="file.UniqueFileName.includes('.docx')" text icon><v-icon>mdi-file-document-outline</v-icon></v-btn>
            <v-btn color="warning" :href="`${$url}/downloadfile/${file.ID}`" v-else text icon><v-icon>text_snippet</v-icon></v-btn>
          </span>
          <v-divider class="my-2" v-if="index != 2"></v-divider>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <p class="mb-4 font-weight-bold">Civil Service</p>
        <div v-for="(form, index) in getForms('Civil Service')" :key="form.Title + form.ID">
          <p class="mb-0" ><a class="title" v-html="form.Title"></a></p>
          <span v-for="file in form.Files" :key="file.ID + file.FileName">
            <v-btn color="red" :href="`${$url}/downloadfile/${file.ID}`" v-if="file.UniqueFileName.includes('.pdf')" text icon><v-icon>mdi-file-pdf-outline</v-icon></v-btn>
            <v-btn color="info" :href="`${$url}/downloadfile/${file.ID}`" v-else text icon><v-icon>mdi-file-document-outline</v-icon></v-btn>
            <!-- <v-btn color="warning" :href="`${$url}/downloadfile/${file.ID}`" v-else text icon><v-icon>text_snippet</v-icon></v-btn> -->
          </span>
          <v-divider class="my-2" v-if="index != 2"></v-divider>
        </div>
      </v-col>
    </v-row>
    <div class="title py-2 px-4 title-div mt-5 mb-3">
      Laws & Regulations
    </div>
    <p class="mb-5" ><a class="title" href="./files/English-constitution.pdf">Constitution</a></p>
    <a href="https://mvlaw.gov.mv/dv">View All Laws & Regulations</a>
    

    <div class="title py-2 px-4 title-div mt-5 mb-3">
      Tweets
    </div>
    <v-row>
      <v-col md="4">
        <v-card>
          <a class="twitter-timeline" data-tweet-limit="3" data-chrome="noheader nofooter transparent" href="https://twitter.com/AGOmv?ref_src=twsrc%5Etfw">Tweets by AGOmv</a> 
        </v-card>
      </v-col>
    </v-row>
    <!-- <div class="title py-2 px-4 title-div mt-5 mb-3">
      Publications
    </div>
    <div class="title py-2 px-4 title-div mt-5 mb-3">
      Reports
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  data: ()=>({
    featuredNews: [],
    latestNews: [],
    content: [],
    forms: [],
    services: [],
    featuredNews: [],
    announcements: [],
    newsType: 'Press Releases',
    pandemic: []
  }),
  watch: {
    newsType: function (val) {
      this.$http.get(`${this.$url}/pagination/2/Media/${val}?limit=3&page=0&sort=date%20desc`).then((responses)=>{
        this.featuredNews = responses.data.data.rows
      })
    }
  },
  async beforeMount() {
    let widgetScript = document.createElement('script')
    widgetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    document.head.appendChild(widgetScript)
    
    // const requestOne = this.$http.get(`${this.$url}/pagination/2/News And Information?limit=20&page=0&sort=id%20desc`)
    // const requestTwo = this.$http.get(`${this.$url}/pagination/2/contents?limit=20&page=0&sort=id%20desc`)
    const requestThree = this.$http.get(`${this.$url}/pagination/2/Form?limit=50&page=0&sort=id%20desc`)
    // const requestFour = this.$http.get(`${this.$url}/pagination/2/services?limit=4&page=0&sort=id%20desc`)
    const requestFive = this.$http.get(`${this.$url}/pagination/2/Media/${this.newsType}?limit=3&page=0&sort=date%20desc`)
    const requestSix = this.$http.get(`${this.$url}/pagination/2/Media/Announcements?limit=5&page=0&sort=date%20desc`)
    const requestSeven = this.$http.get(`${this.$url}/pagination/2/Pandemic?limit=10&page=0&sort=id%20desc`)
    this.$http.all([requestThree, requestFive, requestSix, requestSeven]).then(this.$http.spread((...responses) => {
      // this.latestNews = responses[0].data.data.rows
      // this.content = responses[1].data.data.rows
      this.forms = responses[0].data.data.rows
      // this.services = responses[3].data.data.rows
      this.featuredNews = responses[1].data.data.rows
      this.announcements = responses[2].data.data.rows
      this.pandemic = responses[3].data.data.rows
      console.log(responses[4])
      
      // this.news = this.latestNews.filter(item => item.Category == 'News')
      // this.pressReleases = this.latestNews.filter(item => item.Category == 'Pressrelease')
      // this.announcements = this.latestNews.filter(item => item.Category == 'Iulaan')
      // this.jobs = this.latestNews.filter(item => item.Category == 'Job')
      // use/access the results 
    })).catch(errors => {
      // react on errors.
    })
  },
  methods: {
    getImage(item) {
      if (item.Files && item.Files.length > 0) {
        let images = item.Files.filter(obj => obj.FileType.includes('image'))
        if (images.length > 0) {
          return `${this.$url}/downloadfile/${images[0].ID}`
        }
        else {
          return './images/default-icon.png'
        }
      }
      else {
        return './images/default-icon.png'
      }
    },
    getForms (type) {
      return this.forms.filter((item) => item.Category == type).slice(0,5)
    }
  }
}
</script>
<style>

.news-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  color: #1976d2;
  -webkit-box-orient: vertical;
}
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none !important;
}
.pendamic>div>p>a {
  color: black !important;
}
</style>
